import React, { useState, useEffect } from 'react';
import { TableStriped } from '../../tables/TableStriped';
import { Button, Form, ModalBody, ModalHeader, FormGroup, Label, Row, Col, Input, Container, FormFeedback, TabContent, TabPane, Nav, NavItem, NavLink, Card } from 'reactstrap';
import classnames from 'classnames';
import { RangePrecoded } from './FormsModalRange/RangePrecoded';
import { ReferenceValues } from './FormsModalRange/ReferenceValues';
import { TabMenu } from 'primereact/tabmenu';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Select from 'react-select';

export const ModalRange = (props) => {

    const {
        name, gender, init_value, end_value, years_from, months_from, days_from, years_to, months_to, days_to, text_range,
        handleInputRange, validacionesRange, method, methods, id_type_analyte,
        id_type_precoded_text, precodedTexts, listRanges, addAnalyteNumberRange, removeAnalyteNumberRange, saveTempAnalytesNumberRanges, editAnalyteNumberRange,
        saveEditAnalyteRangeNumber, methodActiveRange, backToCreateRange,
        id_analyte_age_gender_range, handleInputRangePrecoded,
        listRangesPrecoded, addRangePrecoded, saveTempRangePrecoded, removeRangePrecoded, editRangePrecoded, saveEditRangePrecoded, methodActiveRangePrecoded, backToCreateRangePrecoded,
        saveTempAnalytesNumberAlerts, listReferenceValues, isSimple = false,
        tabTypeAnalyte, toggleTypeAnalyte,
        saveTempAnalytesTextAlerts, listReferenceTexts,
    } = props;
        console.log("🚀 ~ ModalRange ~ listRanges:", listRanges)
    const {
        text_range: vTextRange,
        range: vRange,
        overhead: vOverhead,
        method: vMethod,
    } = validacionesRange;

    console.log(method);
    

    const [activeTab, setActiveTab] = useState(1);
    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const type_analyte = parseInt(id_type_analyte);

    let pruebas = new Array();

    listRangesPrecoded.forEach((obj) => {
        let validador = pruebas.find(x => x.id === obj.id_analyte_age_gender_range);
        if (validador === undefined) {
            pruebas.push({
                id: obj.id_analyte_age_gender_range,
                name: obj.age_gender_range_format,
                items: [
                    {
                        id_init: obj.id_analyte_number_custom_value,
                        init_value: obj.init_value,
                        end_value: obj.end_value,
                        text_range: obj.text_range,
                        text_format: obj.text_format
                    }
                ]
            })
        } else {
            validador.items = [
                ...validador.items,
                {
                    id_init: obj.id_analyte_number_custom_value,
                    init_value: obj.init_value,
                    end_value: obj.end_value,
                    text_range: obj.text_range,
                    text_format: obj.text_format
                }
            ]
        }
    });

    // ////console.log(listRanges, "-----rangos");
    // alert("hgika");
    useEffect(() => {
        setActiveTab(1);
    }, [name])

    
    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };


    const actions = (rowData) => {
        return (
            <div
                className="d-flex justify-content-center align-items-center"
                style={{ gap: "3px", marginRight: "3px" }}
            >
                <Button
                    size="sm"
                    onClick={() =>
                        editAnalyteNumberRange(
                            rowData.id_analyte_age_gender_range
                        )
                    }
                    title="Editar rango"
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <i className="fa fa-edit"></i>
                </Button>

                <Button
                    color="danger"
                    size="sm"
                    onClick={() =>
                        removeAnalyteNumberRange(
                            rowData.id_analyte_age_gender_range
                        )
                    }
                    title="Eliminar rango"
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };

    const genderOptions = [
        { value: 0, label: "Indistinto" },
        { value: 1, label: "Femenino" },
        { value: 2, label: "Masculino" }
    ];

    const [activeIndex, setActiveIndex] = useState(0);

    const items = [
        { label: 'Rango de edades y género', icon: 'pi pi-users' },
        { label: 'Valores de referencia y alertas', icon: 'pi pi-bell' },
        ...(type_analyte === 4 || type_analyte === 5
            ? [
                {
                    label: type_analyte === 4
                        ? 'Rango precodificado'
                        : 'Texto condicionado',
                    icon: 'pi pi-sliders-h'
                }
            ]
            : [])
    ];

    return (
        <Col sm="12" style={{background: '#ffffff'}}>
            <br />
            <div
                style={{
                    position: "absolute",
                    top: "-1.25rem",
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "#104f74",
                    color: "#fff",
                    padding: "0.375rem 1.5rem", 
                    borderRadius: "1.5rem",
                    fontWeight: 700,
                    fontSize: "0.875rem", 
                    boxShadow: "0 0.25rem 0.75rem rgba(0,0,0,0.25)",
                    zIndex: 10,
                    display: "flex",
                    alignItems: "center",
                    gap: "0.625rem", 
                    marginTop: "1.875rem", 
                    maxWidth: "90vw",
                    flexWrap: "wrap",
                    textAlign: "center",
                }}
            >
                <i className="icofont icofont-hand-pointer" style={{ fontSize: "0.8125rem", color: "#fff" }} ></i>
                <span style={{ wordBreak: "break-word" }}>Analito: {name}</span>
            </div>

            <TabMenu
                model={items}
                activeIndex={activeIndex}
                onTabChange={(e) => setActiveIndex(e.index)}
                className="custom-tabmenu full-width custom-tabmenu-orange"
                style={{ marginBottom: "15px" }}
            />

            {activeIndex === 0 && (
                <Row>
                    <Col sm="12">
                     <div style={{ 
                            backgroundColor: '#587d95', 
                            color: '#fff', 
                            padding: '5px 10px', 
                            borderRadius: '8px', 
                            marginBottom: '10px', 
                            fontWeight: 'bold', 
                            textAlign: 'center',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                        }}>
                        Gestión de valores de referencia
                    </div>

                    <Row className="position-relative">
                        <Col sm="4">
                            <Card className='shadow-sm border height-equal pricingtable'   style={{ paddingTop: "25px", paddingLeft: "29px", paddingRight: "26px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "116%", transformOrigin: "top left", textAlign: "center", height: "85%" }}>
                                <Form className="position-sticky top-4" role="form" onSubmit={methodActiveRange === "create" ? addAnalyteNumberRange : saveEditAnalyteRangeNumber}>
                                    <Row>
                                        {
                                            methodActiveRange === "edit" &&
                                            <>
                                                <a style={{ cursor: "pointer" }} className="link" onClick={backToCreateRange}>Regresar a creación</a>
                                            </>
                                        }
                                        <FormGroup className={`mb-3 pl-1 pr-1 col-12 ${methodActiveRange === "edit" && "mt-2 border-top"}`}>
                                            <Label className="text-xs">Género</Label>
                                            <Select
                                                disabled={tabTypeAnalyte === 2}
                                                value={genderOptions.find(option => option.value === gender)}
                                                onChange={(selectedOption) => handleInputRange({ target: { name: "gender", value: selectedOption.value } })}
                                                options={genderOptions}
                                                placeholder="Selecciona un género"
                                                isSearchable={true}
                                                className="Select"
                                                classNamePrefix="select"
                                            /> 
                                        </FormGroup>

                                        <FormGroup className="mb-3 pl-1 pr-1 col-12">
                                            <Label className="text-xs">Método</Label>
                                            <Select
                                                classNamePrefix="select"
                                                name="method"
                                                placeholder="Selecciona una opción"
                                                isDisabled={
                                                    tabTypeAnalyte === 2 ||
                                                    methodActiveRange === "edit"
                                                }
                                                options={methods.map((m) => ({
                                                    value: isSimple
                                                        ? m.id_app_code_method
                                                        : m.id_exam_method,
                                                    label: m.name_machine_model
                                                        ? `${m.name_method} / ${m.name_machine_model}`
                                                        : m.name_method,
                                                }))}
                                                value={
                                                    methods
                                                        .map((m) => ({
                                                            value: isSimple
                                                                ? m.id_app_code_method
                                                                : m.id_exam_method,
                                                            label: m.name_machine_model
                                                                ? `${m.name_method} / ${m.name_machine_model}`
                                                                : m.name_method,
                                                        }))
                                                        .find((opt) => opt.value === method) || null
                                                }
                                                onChange={(e) =>
                                                    handleInputRange({
                                                        target: {
                                                            name: "method",
                                                            value: e ? e.value : 0,
                                                        },
                                                    })
                                                }
                                            />

                                            {vMethod && (
                                                <div className="invalid-feedback d-block">
                                                    Debes de seleccionar un método
                                                </div>
                                            )}
                                        </FormGroup>

                                        <FormGroup className={`mb-0 col-12`}>
                                            <Row>
                                                <FormGroup className={`mb-0 pl-1 pr-1 col-12 text-center`}>
                                                    <Label className="text-xs">Edad inicial</Label>
                                                </FormGroup>
                                                <FormGroup className={`mb-3 pl-1 pr-1 col-4`}>
                                                    <Label className="text-xs">Años</Label>
                                                    <Input
                                                        readOnly={tabTypeAnalyte === 2}
                                                        bsSize="sm"
                                                        placeholder="Edad"
                                                        type="number"
                                                        name="years_from"
                                                        value={years_from}
                                                        required={true}
                                                        autoComplete="off"
                                                        onChange={handleInputRange}
                                                        invalid={vOverhead}
                                                        className="form-control form-control-sm input-air-primary"
                                                        style={{ borderRadius: "10px" }}

                                                        //className="text-xs"
                                                        min="0"
                                                        step="1"
                                                    />
                                                </FormGroup>

                                                <FormGroup className={`mb-3 pl-1 pr-1 col-4`}>
                                                    <Label className="text-xs">Meses</Label>
                                                    <Input
                                                        readOnly={tabTypeAnalyte === 2}
                                                        bsSize="sm"
                                                        placeholder="Edad"
                                                        type="number"
                                                        name="months_from"
                                                        value={months_from}
                                                        required={true}
                                                        autoComplete="off"
                                                        onChange={handleInputRange}
                                                        invalid={vOverhead}
                                                        className="form-control form-control-sm input-air-primary"
                                                            style={{ borderRadius: "10px" }}

                                                    //className="text-xs"
                                                    />
                                                </FormGroup>

                                                <FormGroup className={`mb-3 pl-1 pr-1 col-4`}>
                                                    <Label className="text-xs">Dias</Label>
                                                    <Input
                                                        readOnly={tabTypeAnalyte === 2}
                                                        bsSize="sm"
                                                        placeholder="Edad"
                                                        type="number"
                                                        name="days_from"
                                                        value={days_from}
                                                        required={true}
                                                        autoComplete="off"
                                                        onChange={handleInputRange}
                                                        invalid={vOverhead}
                                                        className="form-control form-control-sm input-air-primary"
                                                            style={{ borderRadius: "10px" }}
                                                    //className="text-xs"
                                                    />
                                                </FormGroup>
                                            </Row>
                                        </FormGroup>

                                        <FormGroup className={`mb-0 col-12`}>
                                            <Row>
                                                <FormGroup className={`mb-0 pl-1 pr-1 col-12 text-center`}>
                                                    <Label className="text-xs">Edad final</Label>
                                                </FormGroup>
                                                <FormGroup className={`mb-3 pl-1 pr-1 col-4`}>
                                                    <Label className="text-xs">Años</Label>
                                                    <Input
                                                        readOnly={tabTypeAnalyte === 2}
                                                        bsSize="sm"
                                                        placeholder="Edad"
                                                        type="number"
                                                        name="years_to"
                                                        value={years_to}
                                                        required={true}
                                                        autoComplete="off"
                                                        onChange={handleInputRange}
                                                        invalid={vOverhead}
                                                        className="form-control form-control-sm input-air-primary"
                                                            style={{ borderRadius: "10px" }}

                                                    //className="text-xs"
                                                    />
                                                </FormGroup>

                                                <FormGroup className={`mb-3 pl-1 pr-1 col-4`}>
                                                    <Label className="text-xs">Meses</Label>
                                                    <Input
                                                        readOnly={tabTypeAnalyte === 2}
                                                        bsSize="sm"
                                                        placeholder="Edad"
                                                        type="number"
                                                        name="months_to"
                                                        value={months_to}
                                                        required={true}
                                                        autoComplete="off"
                                                        onChange={handleInputRange}
                                                        invalid={vOverhead}
                                                        className="form-control form-control-sm input-air-primary"
                                                        style={{ borderRadius: "10px" }}

                                                    //className="text-xs"
                                                    />
                                                </FormGroup>

                                                <FormGroup className={`mb-3 pl-1 pr-1 col-4`}>
                                                    <Label className="text-xs">Dias</Label>
                                                    <Input
                                                        readOnly={tabTypeAnalyte === 2}
                                                        bsSize="sm"
                                                        placeholder="Edad"
                                                        type="number"
                                                        name="days_to"
                                                        value={days_to}
                                                        required={true}
                                                        autoComplete="off"
                                                        onChange={handleInputRange}
                                                        invalid={vOverhead}
                                                        className="form-control form-control-sm input-air-primary"
                                                        style={{ borderRadius: "10px" }}

                                                    // className="text-xs"
                                                    />
                                                </FormGroup>
                                            </Row>
                                        </FormGroup>

                                        <FormGroup className={`mb-4 pl-1 pr-1 col-12`}>
                                            <Input type="hidden" invalid={vOverhead} />
                                            <FormFeedback>El rango se esta empalmando con uno ya existente. Verifique su rango</FormFeedback>
                                        </FormGroup>

                                        {
                                            tabTypeAnalyte !== 2 &&
                                            <FormGroup className={`mb-3 pl-1 pr-1 col-12`}>
                                                <Button
                                                    type="submit"
                                                    color="primary"
                                                    className={"btn-analito  btn-sm" + (null ? "disabled progress-bar-animated progress-bar-striped" : "")}
                                                >
                                                    {
                                                        methodActiveRange === "create" ?
                                                            "Añadir rango de edad" : "Editar rango de edad"
                                                    }
                                                </Button>
                                            </FormGroup>
                                        }
                                    </Row>
                                </Form>
                            </Card>
                        </Col>

                        <Col sm="8">
                            <Card className='shadow-sm border height-equal pricingtable'   style={{ paddingTop: "15px", paddingLeft: "15px", paddingRight: "15px", scrollBehavior: "smooth", transform: "scale(0.8)", width: "125%", transformOrigin: "top left", textAlign: "justify" }}>
                                <div style={{ marginTop: "1rem" }}>
                                    <h5
                                        className="pt-1 text-center"
                                        style={{
                                        color: "#0a2754", 
                                        fontWeight: 600,
                                        fontSize: "1rem",
                                        margin: 0,
                                        
                                        }}
                                    >
                                        Lista de valores
                                    </h5>

                                    <p
                                        style={{
                                        backgroundColor: "#fff3cd", 
                                        color: "#856404",           
                                        padding: "0.5rem 1rem",
                                        borderRadius: "0.375rem",
                                        border: "1px solid #ffeeba",
                                        fontSize: "0.875rem",
                                        fontWeight: 500,
                                        marginBottom: "0.5rem",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "0.5rem",
                                        }}
                                    >
                                        <i className="fa fa-exclamation-triangle" style={{ fontSize: "1rem" }}></i>
                                        Eliminar o editar un rango eliminará las alertas
                                    </p>

                               
                                </div>

                        
                                <DataTable
                                    value={listRanges}
                                    paginator={listRanges.length > 10}
                                    rows={10}
                                    rowsPerPageOptions={listRanges.length > 10 ? [10, 50, 100] : []}
                                    className="data-table p-datatable-striped p-datatable-sm"
                                    emptyMessage={
                                        <div className="text-center">
                                        <img
                                            src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                            style={{ width: "35%" }}
                                            alt="Sin lista de valores"
                                        />
                                        <br />
                                        <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                            Sin lista de valores.
                                        </p>
                                        </div>
                                    }
                                    responsiveLayout="scroll"
                                    >
                                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="#" headerStyle={headerStyle} style={cellStyle}/>
                                        <Column field="genero" header="Género" headerStyle={headerStyle} style={cellStyle}/>
                                        <Column 
                                            header="Rango de Edad" 
                                            field="rango_edad" 
                                            body={(rowData) => {let rango = rowData.rango_edad || "";
                                                 if (rango.trim().startsWith("-")) {
                                                    rango = "0 año(s)" + rango; 
                                                }
                                                return rango;              
                                            }}
                                            
                                            headerStyle={headerStyle} 
                                            style={cellStyle} 
                                               
                                        />
                                        <Column
                                            header="Método"
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                            body={(rowData) => {
                                                if (isSimple) {
                                                return rowData.metodo || "";
                                                } else {
                                                const metodo = rowData.metodo || rowData.name_method || "";
                                                const modelo = rowData.machine_model || "";
                                                return modelo ? `${metodo} / ${modelo}` : metodo;
                                                }
                                            }}
                                        />

                                        <Column
                                            header="Valores de Referencia"
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                            body={(rowData) => {

                                                if (rowData.text_reference_values === true) {
                                                return rowData.status;
                                                }

                                                return rowData.reference_values === true ? (
                                                <i className="fa fa-check" style={{ color: "green" }}></i>
                                                ) : (
                                                <i className="fa fa-times" style={{ color: "red" }}></i>
                                                );
                                            }}
                                        />

                                        {tabTypeAnalyte !== 2 && (
                                            <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={cellStyle} />

                                        )}
                                    </DataTable>

                                    {
                                        tabTypeAnalyte !== 2 &&
                                        listRanges.length > 0 &&
                                        <Button
                                            type="button"
                                            color="primary"
                                            className="btn-analito mt-2 btn-sm"
                                            onClick={saveTempAnalytesNumberRanges}
                                            style={{ borderRadius: "10px"}}
                                        >
                                            Confirmar rango de edades
                                        </Button>
                                    }
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>
                
            )}

            {activeIndex === 1 && (
                <Row>
                    <Col sm="12">
                        <ReferenceValues
                            {...{
                                tabTypeAnalyte, listRanges, saveTempAnalytesNumberAlerts, listReferenceValues, saveTempAnalytesTextAlerts, listReferenceTexts,
                            }}
                        />
                    </Col>
                </Row>
            )}

            {activeIndex === 2 && (
                <Row>
                    <Col sm="12">
                        <ModalHeader className="pb-1 pl-2 pr-2">
                            Gestión de rangos precodificados
                        </ModalHeader>

                        <ModalBody className="pt-1">
                            <Row className="position-relative">
                                <Col sm="4">
                                    <Form className="position-sticky top-4" role="form" onSubmit={methodActiveRangePrecoded === "create" ? addRangePrecoded : saveEditRangePrecoded}>
                                        <Row>
                                            {
                                                methodActiveRangePrecoded === "edit" &&
                                                <>
                                                    <a style={{ cursor: "pointer" }} className="link" onClick={backToCreateRangePrecoded}>Regresar a creación</a>
                                                </>
                                            }

                                            <FormGroup className={`mb-3 pl-1 pr-1 col-12 ${methodActiveRangePrecoded === "edit" && "mt-2 border-top"}`}>
                                                <Label className="text-xs">Rango</Label>
                                                <Input
                                                    bsSize="sm"
                                                    placeholder="Género"
                                                    type="select"
                                                    name="id_analyte_age_gender_range"
                                                    value={id_analyte_age_gender_range}
                                                    required={true}
                                                    onChange={handleInputRangePrecoded}
                                                    className="text-xs"
                                                >
                                                    <option value={0}>Selecciona una opción</option>
                                                    {
                                                        listRanges.map((l, key) => {
                                                            return <option
                                                                key={key}
                                                                value={l.id_analyte_age_gender_range}
                                                            >
                                                                {l.rango_edad} // {l.metodo} // {l.genero}
                                                            </option>
                                                        })
                                                    }
                                                </Input>
                                            </FormGroup>

                                            <FormGroup className={`mb-3 pl-1 pr-1 col-6`}>
                                                <Label className="text-xs">Valor inicial</Label>
                                                <Input
                                                    bsSize="sm"
                                                    placeholder="Valor inicial"
                                                    type="number"
                                                    name="init_value"
                                                    value={init_value}
                                                    required={true}
                                                    autoComplete="off"
                                                    onChange={handleInputRangePrecoded}
                                                    className="text-xs"
                                                    invalid={vRange}
                                                />
                                            </FormGroup>
                                            <FormGroup className={`mb-3 pl-1 pr-1 col-6`}>
                                                <Label className="text-xs">Valor final</Label>
                                                <Input
                                                    bsSize="sm"
                                                    placeholder="Valor final"
                                                    type="number"
                                                    name="end_value"
                                                    value={end_value}
                                                    required={true}
                                                    autoComplete="off"
                                                    onChange={handleInputRangePrecoded}
                                                    className="text-xs"
                                                    invalid={vRange}
                                                    step="any"
                                                />
                                            </FormGroup>
                                            <FormGroup className={`mb-0 pl-1 pr-1 col-12`}>
                                                <Input type="hidden" invalid={vRange} />
                                                <FormFeedback>El rango establecido no es valido, el valor final debe ser mayor al inicial</FormFeedback>
                                            </FormGroup>
                                            <FormGroup className={`mb-3 pl-1 pr-1 col-12`}>
                                                <Label className="text-xs">Texto</Label>
                                                {
                                                    parseInt(id_type_precoded_text) === 0
                                                        ?
                                                        <Input
                                                            bsSize="sm"
                                                            placeholder="Texto"
                                                            type="text"
                                                            name="text_range"
                                                            value={text_range}
                                                            autoComplete="off"
                                                            onChange={handleInputRangePrecoded}
                                                            className="text-xs"
                                                            invalid={vTextRange}
                                                        />
                                                        :
                                                        precodedTexts.length > 0 ?
                                                            <Input
                                                                bsSize="sm"
                                                                placeholder="Género"
                                                                type="select"
                                                                name="text_range"
                                                                value={text_range}
                                                                onChange={handleInputRangePrecoded}
                                                                className="text-xs"
                                                                invalid={vTextRange}
                                                            >
                                                                <option value={0}>Selecciona una opción</option>
                                                                {
                                                                    precodedTexts.map((p, key) => {
                                                                        return <option
                                                                            key={key}
                                                                            value={p.id_precoded_text}
                                                                        >
                                                                            {p.text}
                                                                        </option>
                                                                    })
                                                                }
                                                            </Input>
                                                            :
                                                            <Input
                                                                bsSize="sm"
                                                                placeholder="Texto"
                                                                type="text"
                                                                name="text_range"
                                                                value={text_range}
                                                                autoComplete="off"
                                                                onChange={handleInputRangePrecoded}
                                                                className="text-xs"
                                                                invalid={vTextRange}
                                                            />
                                                }
                                                <FormFeedback>Este campo no puede estar vacio</FormFeedback>
                                            </FormGroup>
                                            <FormGroup className={`mb-3 pl-1 pr-1 col-12`}>
                                                <Button
                                                    type="submit"
                                                    color="primary"
                                                    className={"btn-analito btn-sm" + (null ? "disabled progress-bar-animated progress-bar-striped" : "")}
                                                >
                                                    {
                                                        methodActiveRangePrecoded === "create" ?
                                                            "Añadir rango precodificado" : "Editar rango precodificado"
                                                    }
                                                </Button>
                                            </FormGroup>
                                        </Row>
                                    </Form>
                                
                                </Col>
                                
                                <Col sm="8">
                                    <TableStriped
                                        notMaped={["id_analyte_age_gender_range", "text_range", "id_precoded_text", "from", "to"]}
                                        methodsActions={true}
                                        cabeceras={["Rango de edad - método - Género", "Valor inicial", "Valor final", "Texto"]}
                                        items={listRangesPrecoded}
                                        handleDelete={removeRangePrecoded}
                                        handleUpdate={editRangePrecoded}
                                    />
                                    {
                                        listRangesPrecoded.length > 0 &&
                                        <Button
                                            type="button"
                                            color="primary"
                                            className="btn-block mt-2 btn-sm"
                                            onClick={saveTempRangePrecoded}
                                        >
                                            Confirmar rangos precodificados
                                        </Button>
                                    }
                                </Col>
                            </Row>
                        </ModalBody>
                    </Col>
                </Row>
            )}

            <br /><br />
        </Col>
    )
}